import {FILTER_NAMES} from '../base.js'

const FILTER_RANGE_PLACEHOLDER = {from: 'COMMON_FROM', to: 'COMMON_TO'}

export const FILTERS_PLACEHOLDERS = {
  [FILTER_NAMES.ELECTRIC_AUTONOMY]: FILTER_RANGE_PLACEHOLDER,
  [FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY]: FILTER_RANGE_PLACEHOLDER,
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: FILTER_RANGE_PLACEHOLDER,
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: FILTER_RANGE_PLACEHOLDER,
  [FILTER_NAMES.CATEGORY_1]: 'COMMON.SELECT_CATEGORY'
}
